export default __webpack_public_path__ + "static/media/NIN 1.27e6cff2.png";